import { Injectable } from '@angular/core';
import { APIService } from '../api.service';
import urljoin from 'url-join';
import { HttpClient } from '@angular/common/http';
import { tap } from 'rxjs/operators';
import { Subject, BehaviorSubject } from 'rxjs';
import { Parent, User } from 'src/app/models/user';
import { Player } from 'src/app/models/player';

export enum ParentalConsentScope {
  General = 'General',
  WerderBremen = 'WerderBremen',
}

@Injectable({
  providedIn: 'root',
})
export class ProfileService extends APIService {
  readonly onUpdate$ = new Subject<void>();

  constructor(private http: HttpClient) {
    super();
  }

  public get hasProfile(): Promise<boolean> {
    return (async () => {
      return Boolean((await this.getCurrentUserProfile())?.profile);
    })();
  }

  async requestParentalConsent(scope: ParentalConsentScope, data: Parent) {
    switch (scope) {
      case ParentalConsentScope.General:
        const url = urljoin(this.BASE_URL, '/users/consent/request/general/');
        return this.http.post<Parent>(url, data).toPromise();
      case ParentalConsentScope.WerderBremen:
      default:
        break;
    }
  }

  getCurrentUserProfile() {
    const url = urljoin(this.BASE_URL, '/users/me/');
    return this.http.get<User>(url).toPromise();
  }

  getSkillList() {
    const url = urljoin(this.BASE_URL, '/users/skills/');
    return this.http.get(url).toPromise();
  }

  getHandballSkillList() {
    const url = urljoin(this.BASE_URL, '/users/handball-skills/');
    return this.http.get(url).toPromise();
  }

  createProfile(body) {
    const url = urljoin(this.BASE_URL, '/users/me/profile/');
    return this.http
      .post(url, body)
      .pipe(
        tap(() => {
          this.onUpdate$.next();
        })
      )
      .toPromise();
  }

  editProfile(body) {
    const url = urljoin(this.BASE_URL, '/users/me/profile/');
    return this.http
      .patch(url, body)
      .pipe(
        tap(() => {
          this.onUpdate$.next();
        })
      )
      .toPromise();
  }

  deleteProfile() {
    const url = urljoin(this.BASE_URL, '/users/me/profile/');
    return this.http
      .delete(url)
      .pipe(
        tap(() => {
          this.onUpdate$.next();
        })
      )
      .toPromise();
  }

  public async isWerderBremenDataValid() {
    const user = (await this.getCurrentUserProfile()) as Player;
    let canView = Boolean(
      user.allowed_in_werder_bremen_tests && user.profile.club.name
    );
    return canView;
  }
}
